import React from "react";
import { Output } from "../Text";
import { Button } from "@vwfs-bronson/bronson-react";

class SaveButton extends React.Component<SaveButtonProps> {
  render() {
    if (process.env.REACT_APP_ENTRYPOINT !== "heycar") {
      return null;
    }
    return (
      <div id="float-grid" className="o-float-grid">
        <div className="o-float-grid__area" data-float-grid-area="bottom-right">
          <div className="c-action-buttons-container">
            <Button
              action
              icon="semantic-save-local"
              iconReversed
              incognito
              onClick={this.props.onClick}
            >
              {Output.resolve("pages.heyCar.saveButton.helptext")}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

type SaveButtonProps = {
  onClick: () => void;
};

export { SaveButton };
